import React from "react";
import NoticeBox from "./NoticeBox";
import CustomAction from "../../../../controls/CustomAction";

export default function VNRightContent({
  setBookingForm,
  setVaccinessNoticesStep,
  mainColor,
}) {
  const noticeData = [
    {
      status: "approved",
      title: "Approved",
      descTitle:
        "Our facility has received full accreditation for Yellow Fever vaccinations",
      desc: "Certified healthcare professionals available 7 days a week for consultations",
    },
    // {
    //   status: "important",
    //   title: "Important",
    //   descTitle: "Temporary service interruption for routine maintenance",
    //   desc: "Services will resume on Monday. Please check back for updates",
    // },
    // {
    //   status: "declined",
    //   title: "Declined",
    //   descTitle: "Current certification pending renewal",
    //   desc: "We are working with health authorities to restore services soon",
    // },
    // {
    //   status: "approved",
    //   title: "Approved",
    //   descTitle: "Extended vaccination hours now available",
    //   desc: "Evening and weekend appointments can now be scheduled",
    // },
    // {
    //   status: "important",
    //   title: "Important",
    //   descTitle: "New documentation requirements in effect",
    //   desc: "Please bring valid photo ID and previous vaccination records",
    // },
    // {
    //   status: "declined",
    //   title: "Declined",
    //   descTitle: "Facility undergoing staff training period",
    //   desc: "Service temporarily unavailable until staff certification complete",
    // },
    // {
    //   status: "approved",
    //   title: "Approved",
    //   descTitle: "Mobile vaccination unit now operational",
    //   desc: "Serving remote locations within 50-mile radius",
    // },
    // {
    //   status: "important",
    //   title: "Important",
    //   descTitle: "Updated vaccine storage protocols",
    //   desc: "Enhanced safety measures implemented for vaccine handling",
    // },
    // {
    //   status: "declined",
    //   title: "Declined",
    //   descTitle: "Equipment maintenance in progress",
    //   desc: "Services suspended until new equipment installation complete",
    // },
    // {
    //   status: "approved",
    //   title: "Approved",
    //   descTitle: "International travel clinic certification renewed",
    //   desc: "Full range of travel vaccines and consultations available",
    // },
  ];

  return (
    <div className="inner-content vn-right">
      <p className="section-title">Travel Vaccine Notices</p>
      <div className="notice-box-container">
        {noticeData.map((item, index) => (
          <NoticeBox key={index} notice={item} />
        ))}
      </div>
    </div>
  );
}
